"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");






















































































var _index = require("@/utils/index"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { status: '', time: '', page: 1, rows: 10 }, //过滤表单
      pickerOptions: { disabledDate: function disabledDate(time) {return time.getTime() < Date.now() - 24 * 3600 * 1000;} }, statusList: [{ id: 1, name: '已上架' }, { id: 0, name: '未上架' }], //状态列表
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      showAdd: false, //是否显示新增弹窗
      tableData: [], //列表数据
      tableColumn: [{ prop: 'notifyContent', label: '公告文案' }, { prop: 'startTime', label: '弹窗开始时间' }, { prop: 'endTime', label: '弹窗结束时间' }], //表头数据
      regionList: [], //区域列表
      appList: [], //App列表
      announceEdit: false, //是否正在编辑公告
      announceForm: { id: 0, servicesRegionalList: '', notifyContent: '', startTime: '', endTime: '', appUpType: '0', appInfoList: [] }, //新增||编辑表单
      announceFormRule: { servicesRegionalList: [{ required: true, message: '请选择服务区域', trigger: ['change'] }], notifyContent: [{ required: true, message: '请填写弹窗内容', trigger: ['change', 'blur'] }], startTime: [{ required: true, message: '请选择弹窗开始时间', trigger: ['change', 'blur'] }], endTime: [{ required: true, message: '请选择弹窗结束时间', trigger: ['change', 'blur'] }], appInfoList: [{ required: true, message: '请选择弹窗App', trigger: ['change', 'blur'] }] } //表单验证规则
    };}, watch: { showAdd: { handler: function handler(val) {if (val) {this.fetchAppList();}}, deep: true } },


  computed: {
    announceRegions: function announceRegions() {
      return function (row) {
        var res = [];
        row.servicesRegionalList.forEach(function (e) {
          if (e && e.regionalName) {
            res.push(e.regionalName);
          }
        });
        return res.length ? res.join(',') : '暂无';
      };
    },
    announceApps: function announceApps() {
      return function (row) {
        if (row.appUpType == 0) {
          return '全部';
        }
        var res = [];
        row.appInfoList.forEach(function (e) {
          if (e && e.name) {
            res.push(e.name);
          }
        });
        return res.length ? res.join(',') : '暂无';
      };
    },
    announceStatus: function announceStatus() {
      return function (row) {
        if (row.status == 0) {
          return '未上架';
        } else {
          return '已上架';
        }
      };
    } },


  mounted: function mounted() {
    this.fetchRegionList();
    this.fetchAnnouncementList();
  },

  methods: {
    /**
              * 获取App列表
              */
    fetchAppList: function fetchAppList() {var _this = this;
      this.getData('/api/faAppInfo', { page: 1, rows: 999999 }, function (res) {
        _this.appList = res.list;
      });
    },

    /**
        * 获取区域列表
        */
    fetchRegionList: function fetchRegionList() {var _this2 = this;
      this.getData('/api/faServicesRegional/getAll', { page: 1, rows: 9999999 }, function (res) {
        _this2.regionList = res.list;
      });
    },

    /**
        * 获取系统公告通知列表
        */
    fetchAnnouncementList: function fetchAnnouncementList() {var _this3 = this;
      var params = Object.assign({}, this.searchData);
      if (params.time) {
        params.startTime = params.time[0] + ' 00:00:00';
        params.endTime = params.time[1] + ' 23:59:59';
      }
      delete params['time'];
      this.getData('/api/faAppSystemNotify/getFaAppSystemNotify', params, function (res) {
        _this3.tableData = res.list;
        _this3.pageData.page = res.pageNum;
        _this3.pageData.total = res.total;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'status', '');
      this.$set(this.searchData, 'time', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchAnnouncementList();
    },

    /**
        * 上||下架
        */
    offShelfItem: function offShelfItem(row) {var _this4 = this;
      this.$confirm("\u786E\u5B9A".concat(row.status == 1 ? '下架' : '上架', "\u5F53\u524D\u901A\u77E5\uFF1F"), '提示', { type: 'warning' }).then(function (res) {
        //上||下架通知
        _this4.postData('/api/faAppSystemNotify/updateStatus', { id: row.id, status: row.status == 0 ? 1 : 0 }, function (res) {
          _this4.fetchAnnouncementList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 编辑
        */
    editItem: function editItem(row) {
      this.showAdd = true;
      this.$set(this.announceForm, 'id', row.id);
      var services = [];
      row.servicesRegionalList.forEach(function (e) {
        services.push(e.id);
      });
      this.$set(this.announceForm, 'servicesRegionalList', services);
      this.$set(this.announceForm, 'notifyContent', row.notifyContent);
      this.$set(this.announceForm, 'startTime', row.startTime);
      this.$set(this.announceForm, 'endTime', row.endTime);
      this.$set(this.announceForm, 'appUpType', row.appUpType + '');
      var apps = [];
      row.appInfoList.forEach(function (e) {
        apps.push(e.id);
      });
      this.$set(this.announceForm, 'appInfoList', apps);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this5 = this;
      this.$confirm('确定删除当前通知？', '提示', { type: 'warning' }).then(function (res) {
        //删除通知
        _this5.delData("/api/faAppSystemNotify/delete/".concat(row.id), {}, function (res) {
          _this5.fetchAnnouncementList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', val);
      this.fetchAnnouncementList();
    },

    /**
        * Page-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.fetchAnnouncementList();
    },

    /**
        * 时间选择器聚焦
        */
    onDatePickerFocus: function onDatePickerFocus() {
      var date = new Date();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      this.$set(this.pickerOptions, 'selectableRange', "".concat(hour, ":").concat(minute, ":").concat(second, " - 23:59:59"));
    },

    /**
        * 弹窗打开
        */
    onAddDialogOpen: function onAddDialogOpen() {var _this6 = this;
      this.$nextTick(function () {
        _this6.$refs.announceForm.clearValidate();
      });
    },

    /**
        * 新增||编辑弹窗关闭
        */
    onAddDialogClose: function onAddDialogClose() {var _this7 = this;
      this.$nextTick(function () {
        Object.keys(_this7.announceForm).forEach(function (e) {
          _this7.$set(_this7.announceForm, e, e == 'appInfoList' || e == 'servicesRegionalList' ? [] : '');
        });
        _this7.$refs.announceForm.clearValidate();
      });
      this.showAdd = false;
    },

    /**
        * 开始时间-change
        */
    onStartTimeChange: function onStartTimeChange(event) {
      if (this.announceForm.endTime && Date.parse(new Date(event)) > Date.parse(new Date(this.announceForm.endTime))) {
        this.$message({
          message: '开始时间应早于结束时间',
          type: 'error' });

        this.$set(this.announceForm, 'startTime', '');
      }
    },

    /**
        * 结束时间-change
        */
    onEndTimeChange: function onEndTimeChange(event) {
      if (this.announceForm.startTime && Date.parse(new Date(this.announceForm.startTime)) > Date.parse(new Date(event))) {
        this.$message({
          message: '结束时间应晚于开始时间',
          type: 'error' });

        this.$set(this.announceForm, 'endTime', '');
      }
    },

    /**
        * 保存公告
        */
    onSaveAnnounce: function onSaveAnnounce() {var _this8 = this;
      this.$refs.announceForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this8.announceForm);
          if (params.id) {
            //编辑
            var serviceList = [];
            params.servicesRegionalList.forEach(function (e) {
              serviceList.push({ id: e });
            });
            params.servicesRegionalList = serviceList;
            if (params.appUpType == 1) {
              var apps = [];
              params.appInfoList.forEach(function (e) {
                apps.push({ id: e });
              });
              params.appInfoList = apps;
            }
            if (params.startTime.length <= 16) {
              params.startTime = params.startTime + ' 00:00:00';
            }
            if (params.endTime.length <= 16) {
              params.endTime = params.endTime + ' 23:59:59';
            }
            _this8.postData('/api/faAppSystemNotify/update', params, function (res) {
              _this8.onAddDialogClose();
              _this8.fetchAnnouncementList();
            });
          } else {
            //新增
            delete params['id'];
            var _serviceList = [];
            params.servicesRegionalList.forEach(function (e) {
              _serviceList.push({ id: e });
            });
            params.servicesRegionalList = _serviceList;
            if (params.appUpType == 1) {
              var _apps = [];
              params.appInfoList.forEach(function (e) {
                _apps.push({ id: e });
              });
              params.appInfoList = _apps;
            }
            params.startTime = params.startTime + ' 00:00:00';
            params.endTime = params.endTime + ' 23:59:59';
            _this8.postData('/api/faAppSystemNotify/save', params, function (res) {
              _this8.$set(_this8.searchData, 'page', 1);
              _this8.onAddDialogClose();
              _this8.fetchAnnouncementList();
            });
          }
        }
      });
    } } };exports.default = _default;